const appRoles = {
  admin: {
    name: 'admin',
    displayName: 'Admin'
  },
  bulkEmailAdmin: {
    name: 'bulkEmailAdmin',
    displayName: 'Bulk Email Admin'
  },
  anonymous: {
    name: 'anonymous',
    displayName: 'Anonymous',
  }
}

export default appRoles;